import script from './SdsBaseCarouselNavigator.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sds-base-carousel-navigator sds-focus",attrs:{"aria-label":_vm.$t(_vm.direction === 'previous' ? 'previous slide' : 'next slide').toString(),"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('SdsIcon',{staticClass:"sds-base-carousel-navigator__icon",attrs:{"iconName":_vm.direction === 'previous' ? 'navigation-chevron-left' : 'navigation-chevron-right',"size":"lg"}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-095fa126_0", { source: ".sds-base-carousel-navigator[data-v-095fa126]{display:flex;justify-content:center;align-items:center;flex-shrink:0;width:var(--sds-base-carousel-navigator-size);height:var(--sds-base-carousel-navigator-size);padding:0;border-radius:var(--radius-full);border:1px solid var(--system-border-on-elevation-secondary);background-color:var(--system-bg-elevation-layer-2);outline:0;cursor:pointer;pointer-events:all;transition-property:background-color,border-color;transition-duration:.3s;transition-timing-function:ease-out}.sds-base-carousel-navigator[data-v-095fa126]:hover{background-color:var(--system-bg-elevation-layer-2-hover)}.sds-base-carousel-navigator[data-v-095fa126]:active{background-color:var(--system-bg-elevation-layer-2-pressed)}.sds-base-carousel-navigator[data-v-095fa126]:disabled{border-color:transparent;background-color:transparent;cursor:not-allowed}.sds-base-carousel-navigator:disabled .sds-base-carousel-navigator__icon[data-v-095fa126]{color:var(--system-graphics-on-elevation-disabled)}.sds-base-carousel-navigator__icon[data-v-095fa126]{color:var(--system-graphics-on-elevation-tertiary);transition-property:color;transition-duration:.3s;transition-timing-function:ease-out}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-095fa126";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
